import PropTypes from 'prop-types';
import React from 'react';
import BaseButton from 'app/components/common/BaseButton';
import ToggleSwitch from 'app/components/svgs/ToggleSwitch';
import { T } from 'app/components/localization';
import { createStyles } from 'app/utils/css';
import { buttonReset } from 'app/constants/Styles';

function LessonTranslationToggle({ showTranslations, toggleTranslations }) {
  const labelStyle = {
    marginRight: '0.5em',
    lineHeight: '1.1',
    textAlign: 'right',
  };

  return (
    <T>{t =>
      <Styles>{css =>
        <BaseButton
          className={css('translationButton')}
          onClick={toggleTranslations}
        >
          <div style={labelStyle}>
            {t('daily-news.lesson-translation-toggle.label')}
          </div>

          <ToggleSwitch toggledOn={showTranslations} />
        </BaseButton>
      }</Styles>
    }</T>
  );
}

LessonTranslationToggle.propTypes = {
  showTranslations: PropTypes.bool.isRequired,
  toggleTranslations: PropTypes.func.isRequired,
};

const Styles = createStyles({
  translationButton: {
    ...buttonReset,
    display: 'flex',
    alignItems: 'center',
  },
});

export default LessonTranslationToggle;
